<template>
  <div class="cursor-latlng">
    <span class="cursor-latlng__text">{{ latlng_text }}</span>
    <span class="map-scale" ref="map-scale"></span>
  </div>
</template>

<script>
export default {
  name: 'cursor-latlng',
  props: ['lat', 'lng', 'map'],
  data: function() {
    return {
      to_fixed: 2, // 小數進位
      null_text: ' -- ' // 缺值替代文字
    }
  },
  computed: {
    show_lat: function() {
      return this.get_val(this.lat)
    },
    show_lng: function() {
      return this.get_val(this.lng)
    },
    latlng_text: function() {
      return `${this.show_lng}°E ${this.show_lat}°N`
    }
  },
  methods: {
    get_val: function(val) {
      return val ? val.toFixed(this.to_fixed) : this.null_text
    }
  },
  watch: {
    map: function() {
      const tool = L.control
        .scale({
          maxWidth: 110,
          imperial: false
        })
        .addTo(this.map)
      $(tool._mScale).appendTo(this.$refs['map-scale'])
    }
  }
}
</script>

<style lang="css">
.cursor-latlng {
  padding: 0.1em 0.4em;
  color: white;
  font-size: 0.625rem;
  font-family: monospace;
  line-height: 0.75rem;
  background: black;
  display: flex;
  align-items: center;
}
.map-scale .leaflet-control-scale-line {
  display: inline-block;
  padding: 0;
  margin: 0 0.5rem;
  line-height: 1;
  border: unset;
  background-color: var(--aqua-active);
  color: black;
  text-align: center;
}
</style>
